import { HttpClient, HttpXhrBackend } from '@angular/common/http';
import { HttpHeader } from '../header/HttpHeader';
import { JSONData } from '../data/JSONData';
/**
 * Implementa a interface de request para fazer uso do método DELETE do Http
 */
export class HttpDelete {
    //Construtor, onde pode ou não passar um header extra
    constructor(data) {
        this.url = data.url;
        this.data = data.data || new JSONData();
        this.header = data.header || new HttpHeader();
        this.responseType = data.responseType || 'json';
    }
    //Faz a requisição usando o httpclient
    buildRequest() {
        return HttpDelete.httpClient.delete(this.url.buildUrl(), {
            headers: this.data.setHeader(this.header),
            responseType: this.responseType
        });
    }
}
HttpDelete.httpClient = new HttpClient(new HttpXhrBackend({ build: () => new XMLHttpRequest() }));
